module.exports = __webpack_public_path__ + "public/img/ttd-ytc.f45755ce.png";